import React from 'react'
import {Button} from "@themesberg/react-bootstrap";
import PropTypes from "prop-types";
import DotLayout from "./DotLayout";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCalendar} from "@fortawesome/free-solid-svg-icons";
import MyImage from "./MyImage";
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";
import Datetime from "react-datetime";

export default class DateFilterButton extends React.Component{

    constructor(props) {
        super(props);
        let {value} = this.props
        this.state = {
            isOpen : false,
            value : value
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps!==this.props){
            let {value} = this.props
            this.setState({value, isOpen:false})
        }
    }

    renderInput(){
        let {isOpen, value} = this.state
        let {initialValue, isError,errorMessage,title,placeholder, onSelect} = this.props
        let active = value!==undefined;
        return (
            <Button
                size="sm"
                className="d-block w-100"
                variant={(active?"outline-danger":"outline-success")+" align-item-center"}
                style={{backgroundColor:'white', color:(active?"red":"green")}}
                color="danger"
                onClick={(e)=>{
                    e.preventDefault()
                    this.setState({isOpen:!isOpen})
                }}>
                <DotLayout
                    dimension={16}
                    backgroundColor={active?"red":"green"}
                />
                &nbsp;&nbsp;
                {title}
                &nbsp;&nbsp;
                <FontAwesomeIcon icon={faCalendar} />
                {(active===true)?(
                    <>
                        &nbsp;
                        <MyImage
                            src={ApplicationIcons.Icons.logout}
                            style={{width:'20px', height:'20px'}}
                            onClick={(event)=>{
                                event.stopPropagation()
                                event.preventDefault()
                                value = undefined
                                this.setState({isOpen:false, value}, () => {
                                    if(onSelect){
                                        onSelect(value)
                                    }
                                })
                            }}
                        />
                    </>
                ):(undefined)}
            </Button>

        )
    }

    render() {
        let {isOpen, value} = this.state
        let {initialValue, isError,errorMessage,title,placeholder, onSelect, minimumDate, maximumDate} = this.props
        return (
            <React.Fragment>
                <Datetime
                    open={isOpen}
                    value={value}
                    isValidDate={currentDate => {
                        if(minimumDate) {
                            if (!currentDate.isAfter(minimumDate)) {
                                return false;
                            }
                        }
                        if(maximumDate){
                            if(!currentDate.isBefore(maximumDate)){
                                return false ;
                            }
                        }
                        return true ;
                    }}
                    initialValue={value}
                    closeOnClickOutside={true}
                    onChange={date => {
                        this.setState({isOpen:false, value:date}, () => {
                            if(onSelect){
                                onSelect(date)
                            }
                        })
                    }}
                    renderInput={props => this.renderInput()}/>
            </React.Fragment>
        );
    }
}
DateFilterButton.propTypes = {
    onClick:PropTypes.func.isRequired,
    title:PropTypes.string,
    value:PropTypes.any,
    minimumDate:PropTypes.any,
    maximumDate:PropTypes.any,
    onSelect:PropTypes.func,
}